import * as React from 'react';

import { scrollToElement } from '@cian/newbuilding-utils';
import { setHash } from '../../utils';
import styles from './PikLogo.css';

export const PikLogo: React.FC = () => {
  const handleLogoClick = React.useCallback((event: React.SyntheticEvent) => {
    event.preventDefault();

    setHash('');
    scrollToElement({ selector: 'body' });
  }, []);

  return (
    <a className={styles['container']} onClick={handleLogoClick} href="#">
      <img className="" src="https://static.cdn-cian.ru/media/images/pik_orange.svg" alt="ПИК" width={54} height={16} />
    </a>
  );
};
